
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.js";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { Fragment } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.scss';
import Customer from './Pages/Customer';
import Dashboard from './Pages/Dashboard';
import Error404 from './Pages/Error404';
import FormOptions from './Pages/form-options';
import DetilChoiceGroup from "./Pages/form-options/DetailChoiceGroup";
import DetailSection from './Pages/form-options/DetailSection';
import DetilElement from "./Pages/form-options/DetilElement";
import FormInspeksi from './Pages/FormInspeksi';
import FormCategory from './Pages/FormInspeksi/FormCategory';
import FormPemeriksaan from './Pages/FormInspeksi/FormPemeriksaan';
import MainForm from './Pages/FormInspeksi/MainForm';
import MainFormInspector from './Pages/inspector/form/MainFormInspector';
import Inspeksi from './Pages/Inspeksi';
import DetilInspeksi from './Pages/Inspeksi/DetilInspeksi';
import Invoice from './Pages/Invoice';
import CetakInvoice from './Pages/Invoice/CetakInvoice';
import CreateInvoice from './Pages/Invoice/CreateInvoice';
import UpdateInvoice from './Pages/Invoice/UpdateInvoice';
import Login from './Pages/Login';
import Offer from './Pages/Offer';
import CetakOffer from './Pages/Offer/CetakOffer';
import CreateOffer from './Pages/Offer/CreateOffer';
import DetilOffer from './Pages/Offer/DetilOffer';
import UpdateOffer from './Pages/Offer/UpdateOffer';
import Options from './Pages/Options';
import PrivateRoute from './Pages/PrivateRoute';
import PurchaseInvoice from './Pages/PurchaseInvoice';
import CetakPurchaseInvoice from './Pages/PurchaseInvoice/CetakPurchaseInvoice';
import CreatePurchaseInvoice from './Pages/PurchaseInvoice/CreatePurchaseInvoice';
import UpdatePurchaseInvoice from './Pages/PurchaseInvoice/UpdatePurchaseInvoice';
import Users from './Pages/Users';
import ChangeProfile from './Pages/Users/ChangeProfile';
import Brand from './Pages/Brand';
import Type from './Pages/Type';
import { AppConfigProvider } from './Utils/AppConfigContext';
import FormSectionInspector from './Pages/inspector/form/FormSectionInspector';
import DetilInspector from './Pages/inspector/DetilInspector';

function App() {
  return (
    <AppConfigProvider>
      <BrowserRouter>
        <Fragment>
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route exact element={<PrivateRoute />}>
              <Route exact path="/" element={<Dashboard />} />
              <Route exact path="/customer" element={<Customer />} />
              <Route exact path="/inspeksi" element={<Inspeksi />} />
              <Route exact path="/inspeksi/detil/:item_id" element={<DetilInspeksi />} />
              <Route exact path="/penawaran" element={<Offer />} />
              <Route exact path="/penawaran/create" element={<CreateOffer />} />
              <Route exact path="/penawaran/create/:customer_id" element={<CreateOffer />} />
              <Route exact path="/penawaran/update/:offer_id" element={<UpdateOffer />} />
              <Route exact path="/penawaran/detil/:offer_id" element={<DetilOffer />} />
              <Route exact path="/penawaran/cetak/:offer_id" element={<CetakOffer />} />
              <Route exact path="/invoice" element={<Invoice />} />
              <Route exact path="/invoice/create" element={<CreateInvoice />} />
              <Route exact path="/invoice/create/:offer_id" element={<CreateInvoice />} />
              <Route exact path="/invoice/update/:invoice_id" element={<UpdateInvoice />} />
              <Route exact path="/invoice/cetak/:invoice_id" element={<CetakInvoice />} />
              <Route exact path="/pembayaran" element={<PurchaseInvoice />} />
              <Route exact path="/pembayaran/create" element={<CreatePurchaseInvoice />} />
              <Route exact path="/pembayaran/create/:invoice_id" element={<CreatePurchaseInvoice />} />
              <Route exact path="/pembayaran/update/:purchase_id" element={<UpdatePurchaseInvoice />} />
              <Route exact path="/pembayaran/cetak/:purchase_id" element={<CetakPurchaseInvoice />} />
              <Route exact path="/form-inspeksi/:offer_id" element={<FormInspeksi />} />
              <Route exact path="/form-inspeksi/:offer_id/:index" element={<FormInspeksi />} />
              <Route exact path="/form-inspeksi/:offer_id/:index/:category" element={<FormInspeksi />} />
              <Route exact path="/inspeksi/:offer_id" element={<MainForm />} />
              <Route exact path="/inspeksi/:item_id" element={<MainForm />} />
              <Route exact path="/inspeksi/:item_id/hasil-pemeriksaan" element={<FormPemeriksaan />} />
              <Route exact path="/inspeksi/:item_id/:category" element={<FormCategory />} />
              {/* New Inspection */}
              <Route exact path="/inspector/:offer_id" element={<MainFormInspector />} />
              <Route exact path="/inspector/:offer_id/:section_id" element={<FormSectionInspector />} />
              <Route exact path="/inspector/detil/:item_id" element={<DetilInspector />} />
              {/* End New Inspection */}
              <Route exact path="/users" element={<Users />} />
              <Route exact path="/account/profile" element={<ChangeProfile />} />
              <Route exact path="/options" element={<Options />} />
              <Route exact path="/options/master/brand" element={<Brand />} />
              <Route exact path="/options/master/type" element={<Type />} />
              <Route exact path="/form-options" element={<FormOptions />} />
              <Route exact path="/form-options/:section_id" element={<DetailSection />} />
              <Route exact path="/form-options/:section_id/:element_id" element={<DetilElement />} />
               <Route exact path="/form-options/:section_id/:element_id/:choice_group_id" element={<DetilChoiceGroup />} />
            </Route>
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Fragment>
      </BrowserRouter>
    </AppConfigProvider>
  );
}

export default App;
